export var navigate = function navigate(href) {
  if (typeof window !== 'undefined') {
    if (!window.__navigateBlockKit) {
      window.__navigateBlockKit = function (href) {
        window.location.href = href;
      };
    }
    window.__navigateBlockKit(href);
  }
};